import api from "./api";

export default {
  mixins: [ api ],
  methods: {
    // Получение списка исполнителей
    async getWorkers(data) {
      let params = this.makeSearchParams(data);
      let sorting = this.makeSortParams(data);

      if (data.town > 0) {
        params.set("town", data.town);
      }

      if (data.active) {
        params.set("active", data.active);
      }

      if (data.level_efficiency !== '') {
        params.set("level_efficiency", data.level_efficiency);
      }

      if (data.status_id > 0) {
        params.set("status_id", data.status_id);
      }

      return await this.get(`workers?${params.toString()}${sorting}`);
    },
    // Получение исполнителя по id
    async getWorkerById(id) {
      return await this.get(`workers/id/${id}`);
    },
    // Создание исполнителя
    async postWorker(data) {
      return await this.post('workers', data);
    },
    // Изменение исполнителя
    async putWorker(data) {
      return await this.put(`workers/${data.id}`, data);
    },
    // Удаление исполнителя
    async deleteWorker(data) {
      return await this.delete(`workers/${data.id}`, null);
    },

    // Получение расходов исполнителя по id
    async getWorkerCostsById(id) {
      return await this.get(`worker_costs/worker_id/${id}`);
    },
    // Создание расходов исполнителя
    async postWorkerCosts(data, id) {
      return await this.post(`worker_costs/worker_id/${id}`, data);
    },

    // Создание файла паспорта исполнителя
    async postWorkerPassportFile(id, formData) {
      return await this.post(`workers/import/${id}`, formData);
    },
    // Получение файла паспорта исполнителя
    async getWorkerFile(id) {
      return await this.getFile(`workers/id/${id}/passport`, {ignore404: true});
    },

    // Получение последних заявок исполнителя
    async getWorkerLastTasks(id) {
      return await this.get(`workers/id/${id}/last_tasks`);
    },
  }
}



// WEBPACK FOOTER //
// ./src/network/workers.js